import React, { useState } from 'react'
import _ from 'underscore'

import CreateEventWizard from '../components/wizard/CreateEventWizard'
import Modal from '../../common/components/Modal'
import EventMock from './wizard/lib/EventMock'

const CreateEventModal = props => {
  const {
    encoders,
    showOverlay,
    hideModals,
    actions,
    timeZone,
    showCreatedModal,
    visible,
  } = props
    const [lastEvent, setLastEvent] = useState(null)
    if (!visible) return null
    return (
      <Modal cancelModal={showCreatedModal}>
        <Modal.Header>Create a New Event</Modal.Header>

        <CreateEventWizard
          showOverlay={showOverlay}
          source="event-list"
          encoders={encoders}
          initialEdits={lastEvent}
          actions={{
            add: (payload, func) => {
              showCreatedModal();
              actions.events.add(payload, func)
              setLastEvent({...EventMock.getDefaultState().edits, ...payload});
            },
            addMultiple: (payload, func) => {
              setTimeout(() => {
                func(null, null)
              }, 1000)
              actions.events.add(payload, (err, resp) => {

              })
              hideModals()
              showOverlay()
            }
          }}
          timeZone={timeZone}
        />
      </Modal>
    );

}

export default CreateEventModal